/**
 * Time input field with auto-fill behavior
 */

import React, { useRef } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type TimeFieldProps = Omit<TextFieldProps, 'type'> & {
  value: string | null | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const TimeField: React.FC<TimeFieldProps> = ({
  value,
  onChange,
  size = 'small',
  fullWidth = true,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    // Auto-fill with "18:00" if empty
    if (!value || value === '') {
      const syntheticEvent = {
        ...event,
        target: {
          ...event.target,
          value: '18:00',
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(syntheticEvent);

      // Auto-select the filled value after a brief delay
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.select();
        }
      }, 0);
    }

    // Call original onFocus if provided
    if (rest.onFocus) {
      rest.onFocus(event);
    }
  };

  return (
    <TextField
      {...rest}
      inputRef={inputRef}
      type="time"
      value={value || ''}
      onChange={onChange}
      onFocus={handleFocus}
      size={size}
      fullWidth={fullWidth}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};
